<div class="subpage-container">
	<app-alert
		*ngIf="leadRequest.status === LeadStatus.REJECTED"
		[alertType]="AlertTypes.DANGER"
		[content]="alertContent"
		[marginBottom]="8"
	></app-alert>
	<ng-template #alertContent>
		This lead request has been marked as rejected and changes are no longer possible. If you need to make changes, please recover the
		request.
	</ng-template>

	<button type="button" class="btn btn-sm btn-primary w-100" (click)="openScheduleItemsListOffcanvas()">
		Schedule
		<i class="bi bi-plus"> </i>
	</button>

	<app-step-navigator [stepConfig]="navigationConfig" [(selectedStep)]="selectedStep"></app-step-navigator>

	<hr />

	<ng-container [ngSwitch]="selectedStep.switchCase">
		<ng-container *ngSwitchCase="LeadRequestViewOptions.CONTACT_DETAILS">
			<div class="section-column">
				<div class="section-column">
					<div class="btn-container">
						<button class="btn btn-sm btn-success btn-whatsapp w-100" (click)="openClientWhatsApp()">
							<i class="bi bi-whatsapp"></i>
							WhatsApp
						</button>
						<button (click)="viewClient()" class="btn btn-sm btn-primary w-100" type="button">
							<i class="bi bi-arrow-up-right-circle"> </i>
							View Client
						</button>
					</div>

					<div class="section-information">
						<div class="label">
							<div class="name">Customer Name</div>
							<div class="value">{{ client.client.clientName }}</div>
						</div>
						<ng-container *ngIf="client.properties.length">
							<div class="label">
								<div class="name">Properties</div>
								<div class="value">
									<ng-container *ngFor="let property of client.properties">
										<app-link-location [property]="property" [maxCharacters]="30"></app-link-location>
									</ng-container>
								</div>
							</div>
						</ng-container>
						<div class="label">
							<div class="name">Phone</div>
							<div class="value">
								<app-link-phone-number [phoneNumber]="client.client.clientNumber"></app-link-phone-number>
							</div>
						</div>
						<div class="label">
							<div class="name">Email</div>
							<div class="value">
								<app-link-email [email]="client.client.clientEmail"></app-link-email>
							</div>
						</div>
					</div>
				</div>
				<div class="section-column">
					<h6 class="text-primary">Internal Client Notes</h6>
					<textarea [disabled]="readonlyView" class="form-control" placeholder="Client Internal Notes" readonly>{{
						client.client.internalNotes
					}}</textarea>
				</div>
			</div>
		</ng-container>
		<ng-container *ngSwitchCase="LeadRequestViewOptions.CLIENT_REQUIREMENTS">
			<div class="section-column">
				<div class="section-column">
					<h6 class="text-primary">Request Information</h6>
					<div class="section-information">
						<div class="label">
							<div class="name">Submitted Date</div>
							<div class="value">{{ leadRequest.createdDate.toMillis() | date: 'dd/MM/yyyy' }}</div>
						</div>
						<ng-container *ngIf="leadRequest.requestType === LeadRequestType.ON_SITE_VISIT">
							<div class="label">
								<div class="name">Requested Date</div>
								<div class="value">
									<ng-container [ngSwitch]="leadRequest.onSiteVisitAssessment?.dateTime?.type">
										<ng-container *ngSwitchCase="LeadRequestDateTimeType.REQUEST">
											{{
												leadRequest.onSiteVisitAssessment?.dateTime?.requestedDate
													| ngbDateToDate
													| date: 'dd/MM/yyyy'
											}}
										</ng-container>
										<ng-container *ngSwitchCase="LeadRequestDateTimeType.ASAP"> ASAP </ng-container>
										<ng-container *ngSwitchDefault> N/A </ng-container>
									</ng-container>
								</div>
							</div>
							<div class="label">
								<div class="name">Time</div>
								<div class="value">
									<ng-container [ngSwitch]="leadRequest.onSiteVisitAssessment?.dateTime?.type">
										<ng-container *ngSwitchCase="LeadRequestDateTimeType.REQUEST">
											{{ leadRequest.onSiteVisitAssessment?.dateTime?.requestedTimeWindow }}
										</ng-container>
										<ng-container *ngSwitchCase="LeadRequestDateTimeType.ASAP"> ASAP </ng-container>
										<ng-container *ngSwitchDefault> N/A </ng-container>
									</ng-container>
								</div>
							</div>
						</ng-container>
						<div class="label">
							<div class="name">
								Address
								<ng-container *ngIf="leadRequest.personalDetails.installationAddress?.fullAddress">
									<button
										type="button"
										class="btn btn-sm btn-outline-primary border-0"
										title="Edit"
										(click)="editProperty()"
									>
										<i class="bi bi-pencil-fill"> </i>
									</button>
								</ng-container>
							</div>
							<div class="value">
								<ng-container *ngIf="leadRequest.personalDetails.installationAddress?.fullAddress; else propertyAdd">
									<app-link-location
										[property]="leadRequest.personalDetails.installationAddress"
										[maxCharacters]="30"
									></app-link-location>
								</ng-container>
								<ng-template #propertyAdd>
									<button type="button" class="btn btn-sm btn-primary" (click)="addProperty()">
										<i class="bi bi-plus"> </i>
										Add
									</button>
								</ng-template>
							</div>
						</div>
					</div>
				</div>

				<ng-container *ngIf="leadRequest.personalDetails.customQuestions?.length">
					<div class="section-column">
						<h6 class="text-primary">Additional Information</h6>
						<ng-container *ngFor="let customQuestion of leadRequest.personalDetails.customQuestions">
							<div class="section-information">
								<div class="label">
									<div class="name">{{ customQuestion.question }}</div>
									<div class="value">{{ customQuestion.answer | nullDefault: 'N/A' }}</div>
								</div>
							</div>
						</ng-container>
					</div>
				</ng-container>

				<div class="section-column">
					<h6 class="text-primary">Assessment Type</h6>
					<ng-container *ngIf="leadRequest.requestType === LeadRequestType.ON_SITE_VISIT">
						<div class="section-information">
							<div class="label">
								<div class="name">Requested Assessment</div>
								<div class="value">{{ leadRequest.onSiteVisitAssessment?.serviceType | nullDefault: 'N/A' }}</div>
							</div>
						</div>
						<ng-container *ngIf="leadRequest.onSiteVisitAssessment?.customQuestions?.length">
							<ng-container *ngFor="let customQuestion of leadRequest.onSiteVisitAssessment?.customQuestions">
								<div class="section-information">
									<div class="label">
										<div class="name">{{ customQuestion.question }}</div>
										<div class="value">{{ customQuestion.answer | nullDefault: 'N/A' }}</div>
									</div>
								</div>
							</ng-container>
						</ng-container>
					</ng-container>
					<ng-container *ngIf="leadRequest.requestType === LeadRequestType.CALL">
						<div class="section-information">
							<div class="label">
								<div class="name">Requested Assessment</div>
								<div class="value">Call</div>
							</div>
						</div>
						<ng-container *ngIf="leadRequest.callAssessment?.customQuestions?.length">
							<ng-container *ngFor="let customQuestion of leadRequest.callAssessment?.customQuestions">
								<div class="section-information">
									<div class="label">
										<div class="name">{{ customQuestion.question }}</div>
										<div class="value">{{ customQuestion.answer | nullDefault: 'N/A' }}</div>
									</div>
								</div>
							</ng-container>
						</ng-container>
					</ng-container>
				</div>
				<div class="section-column">
					<h6 class="text-primary">Assessment Notes</h6>
					<div class="section-information">
						<div class="label">
							<ng-container *ngIf="leadRequest.requestType === LeadRequestType.ON_SITE_VISIT">
								<textarea
									class="form-control"
									[style.height.px]="200"
									placeholder="Assessment Notes"
									readonly
									[disabled]="readonlyView"
									>{{ leadRequest.onSiteVisitAssessment?.notes }}</textarea
								>
							</ng-container>
							<ng-container *ngIf="leadRequest.requestType === LeadRequestType.CALL">
								<textarea
									class="form-control"
									[style.height.px]="200"
									placeholder="Assessment Notes"
									readonly
									[disabled]="readonlyView"
									>{{ leadRequest.callAssessment?.callNotes }}</textarea
								>
							</ng-container>
						</div>
					</div>
				</div>
			</div>
		</ng-container>
		<ng-container *ngSwitchCase="LeadRequestViewOptions.INTERNAL_NOTES">
			<div body class="section-column">
				<h6 class="text-primary">Internal Notes</h6>
				<app-textarea-control
					[formGroup]="internalNotesForm"
					[resizable]="true"
					[heightPx]="150"
					label="Internal Notes"
					name="internalNotes"
					placeholder="Internal Notes"
				></app-textarea-control>
			</div>
		</ng-container>
	</ng-container>
</div>
